import { OptionTitle } from "./OptionTitle"

export function getOptionTitlesFromArray(options: Array<OptionTitle>, valuesArray: Array<string>): Array<string> {
  return valuesArray?.map((value) => getOptionTitle(options, value))
}

export function getOptionTitle(options: Array<OptionTitle>, value: string): string {
  return options.find((option) => option.id === value)?.title
}

export function capitalizeFirstLetter(word: string): string {
  return word && word.charAt(0).toUpperCase() + word.toLowerCase().slice(1)
}

export function lowercaseFirstLetter(word: string): string {
  return word && word.charAt(0).toLowerCase() + word.slice(1)
}
